import md5 from 'blueimp-md5'
import QRCode from 'qrcode.react'
import React, { useContext, useEffect } from 'react'
import Context from '../../context'

function QrCodeModal() {
  const { qrCodeData, setQrCodeData } = useContext(Context)

  useEffect(() => {
    console.log(qrCodeData.id, md5(qrCodeData.id))
  }, [qrCodeData])

  return (
    <div className="modal fade" id="qrCodeModal" tabIndex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered " role="document">
        <div className="modal-content alert alert-danger">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">
              {qrCodeData.name}
            </h5>
          </div>
          <div className="modal-body d-flex justify-content-center align-content-center">
            <QRCode
              value={`https://clube.gazetadopovo.com.br/?route=${md5(qrCodeData.id)}`}
              style={{ height: '300px', width: '300px' }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QrCodeModal
